import { DashboardMetrics, RevenueTrend, OrderDistribution, RecentOrder, Order, Product, Category, Table, Brand, Customer } from '../types';

export const mockDashboardMetrics: DashboardMetrics = {
  totalOrders: 1234,
  revenue: 56789,
  activeUsers: 456,
  orderGrowth: 12,
  revenueGrowth: 0,
  userGrowth: 5
};

export const mockRevenueTrend: RevenueTrend[] = [
  { date: '2024-01-01', amount: 45000 },
  { date: '2024-01-08', amount: 52000 },
  { date: '2024-01-15', amount: 48000 },
  { date: '2024-01-22', amount: 55000 },
  { date: '2024-01-29', amount: 56789 }
];

export const mockOrderDistribution: OrderDistribution[] = [
  { category: 'Main Course', count: 450, percentage: 36 },
  { category: 'Appetizers', count: 320, percentage: 26 },
  { category: 'Desserts', count: 464, percentage: 38 }
];

export const mockRecentOrders: RecentOrder[] = [
  { id: '1', customerName: 'Alex', amount: 250, date: '2024-01-29' },
  { id: '2', customerName: 'Jordan', amount: 180, date: '2024-01-28' },
  { id: '3', customerName: 'Taylor', amount: 320, date: '2024-01-27' }
];

export const mockOrders: Order[] = [
  {
    id: '12343270',
    customerName: 'Customer Name',
    customerId: 'ABC123',
    amount: 1200,
    status: 'delivered',
    date: '2024-01-26',
    items: [
      { id: '1', productName: 'Margherita Pizza', quantity: 2, price: 12.99 }
    ]
  },
  {
    id: '017345',
    customerName: 'Another Customer',
    customerId: 'DEF456',
    amount: 850,
    status: 'shipped',
    date: '2024-01-25',
    items: [
      { id: '2', productName: 'Chicken Burger', quantity: 3, price: 11.50 }
    ]
  },
  {
    id: '3644332271',
    customerName: 'Fourth Customer',
    customerId: 'GHI789',
    amount: 600,
    status: 'shipped',
    date: '2024-01-24',
    items: [
      { id: '3', productName: 'Caesar Salad', quantity: 2, price: 8.99 }
    ]
  }
];

export const mockProducts: Product[] = [
  {
    id: '1',
    name: 'Margherita Pizza',
    description: 'Classic Italian pizza with fresh mozzarella, tomatoes, and basil',
    price: 12.99,
    stock: 100,
    category: 'Main Course',
    brand: 'Italian Kitchen',
    image: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&h=400&fit=crop'
  },
  {
    id: '2',
    name: 'Chicken Burger',
    description: 'Juicy grilled chicken burger with lettuce, tomato, and special sauce',
    price: 11.50,
    stock: 85,
    category: 'Main Course',
    brand: 'Burger House',
    image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400&h=400&fit=crop'
  },
  {
    id: '3',
    name: 'Caesar Salad',
    description: 'Fresh romaine lettuce with parmesan, croutons, and Caesar dressing',
    price: 8.99,
    stock: 50,
    category: 'Appetizers',
    brand: 'Fresh Garden',
    image: 'https://images.unsplash.com/photo-1546793665-c74683f339c1?w=400&h=400&fit=crop'
  },
  {
    id: '4',
    name: 'Chocolate Lava Cake',
    description: 'Warm chocolate cake with a molten center, served with vanilla ice cream',
    price: 7.99,
    stock: 30,
    category: 'Desserts',
    brand: 'Sweet Treats',
    image: 'https://images.unsplash.com/photo-1624353365286-3f8d62daad51?w=400&h=400&fit=crop'
  },
  {
    id: '5',
    name: 'Spaghetti Carbonara',
    description: 'Creamy pasta with bacon, eggs, and parmesan cheese',
    price: 14.99,
    stock: 60,
    category: 'Main Course',
    brand: 'Italian Kitchen',
    image: 'https://images.unsplash.com/photo-1612874742237-6526221588e3?w=400&h=400&fit=crop'
  },
  {
    id: '6',
    name: 'Mozzarella Sticks',
    description: 'Crispy fried mozzarella sticks with marinara sauce',
    price: 6.99,
    stock: 75,
    category: 'Appetizers',
    brand: 'Snack Bar',
    image: 'https://images.unsplash.com/photo-1531749668029-2db88e4276c7?w=400&h=400&fit=crop'
  }
];

export const mockCategories: Category[] = [
  { id: '1', name: 'Main Course', icon: '🍽️', description: 'Delicious main dishes' },
  { id: '2', name: 'Appetizers', icon: '🥗', description: 'Start your meal right' },
  { id: '3', name: 'Desserts', icon: '🍰', description: 'Sweet endings' },
  { id: '4', name: 'Beverages', icon: '🥤', description: 'Refreshing drinks' },
  { id: '5', name: 'Breakfast', icon: '🍳', description: 'Morning delights' },
  { id: '6', name: 'Specials', icon: '⭐', description: 'Chef recommendations' }
];

export const mockTables: Table[] = [
  { id: '1', tableNumber: 'T01', status: 'available', capacity: 4, location: 'Main Hall' },
  { id: '2', tableNumber: 'T02', status: 'occupied', capacity: 2, location: 'Main Hall' },
  { id: '3', tableNumber: 'T03', status: 'reserved', capacity: 6, location: 'Private Room' },
  { id: '4', tableNumber: 'T04', status: 'available', capacity: 4, location: 'Terrace' }
];

export const mockCustomers: Customer[] = [
  {
    id: 'customer-1',
    email: 'test@example.com',
    name: 'Test Customer',
    phone: '9876543210',
    address: '123 Test Street',
    city: 'Test City',
    customerId: 'CUST001',
    profilePicture: '',
    registrationDate: '2024-01-01',
    totalOrders: 0,
    totalSpent: 0
  },
  {
    id: 'customer-2',
    email: 'test2@example.com',
    name: 'Test Customer 2',
    phone: '9876543211',
    address: '456 Test Avenue',
    city: 'Test City 2',
    customerId: 'CUST002',
    profilePicture: '',
    registrationDate: '2024-01-02',
    totalOrders: 0,
    totalSpent: 0
  },
  {
    id: 'customer-3',
    email: 'test3@example.com',
    name: 'Test Customer 3',
    phone: '9876543212',
    address: '789 Test Road',
    city: 'Test City 3',
    customerId: 'CUST003',
    profilePicture: '',
    registrationDate: '2024-01-03',
    totalOrders: 0,
    totalSpent: 0
  }
];

export const mockBrands: Brand[] = [
  { id: '1', name: 'Italian Kitchen', image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=100&h=100&fit=crop', description: 'Authentic Italian cuisine' },
  { id: '2', name: 'Burger House', image: 'https://images.unsplash.com/photo-1550547660-d9450f859349?w=100&h=100&fit=crop', description: 'Gourmet burgers & more' },
  { id: '3', name: 'Fresh Garden', image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=100&h=100&fit=crop', description: 'Healthy & fresh salads' },
  { id: '4', name: 'Sweet Treats', image: 'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=100&h=100&fit=crop', description: 'Delightful desserts' },
  { id: '5', name: 'Snack Bar', image: 'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=100&h=100&fit=crop', description: 'Quick bites & snacks' },
  { id: '6', name: 'Beverage Co', image: 'https://images.unsplash.com/photo-1437418747212-8d9709afab22?w=100&h=100&fit=crop', description: 'Refreshing drinks' }
];

export const mockCustomerOrders: Order[] = [
  {
    id: '1234567890',
    customerName: 'Ethan Carter',
    customerId: 'JKL012',
    amount: 250.00,
    status: 'delivered',
    date: '2024-07-26',
    items: [
      { id: '1', productName: 'Margherita Pizza', quantity: 2, price: 12.99 }
    ]
  },
  {
    id: '9876543210',
    customerName: 'Ethan Carter',
    customerId: 'JKL012',
    amount: 180.50,
    status: 'delivered',
    date: '2024-07-20',
    items: [
      { id: '2', productName: 'Chicken Burger', quantity: 1, price: 11.50 }
    ]
  },
  {
    id: '5678901234',
    customerName: 'Ethan Carter',
    customerId: 'JKL012',
    amount: 520.00,
    status: 'shipped',
    date: '2024-07-15',
    items: [
      { id: '3', productName: 'Spaghetti Carbonara', quantity: 2, price: 14.99 }
    ]
  },
  {
    id: '3456789012',
    customerName: 'Ethan Carter',
    customerId: 'JKL012',
    amount: 85.75,
    status: 'delivered',
    date: '2024-07-10',
    items: [
      { id: '4', productName: 'Chocolate Lava Cake', quantity: 1, price: 7.99 }
    ]
  }
];
